import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "position"
    }}>{`Position`}</h1>
    <p>{`Text position options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`NORMAL`}</strong>{` = 1852797549`}</p>
      <p parentName="blockquote">{`Normal position`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPERSCRIPT`}</strong>{` = 1936749411`}</p>
      <p parentName="blockquote">{`Superscripts the text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUBSCRIPT`}</strong>{` = 1935831907`}</p>
      <p parentName="blockquote">{`Subscripts the text.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OT_SUPERSCRIPT`}</strong>{` = 1884247155`}</p>
      <p parentName="blockquote">{`For OpenType fonts, uses--if available--raised glyphs that are sized correctly relative to the surrounding characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OT_SUBSCRIPT`}</strong>{` = 1884247138`}</p>
      <p parentName="blockquote">{`For OpenType fonts, uses--if available--lowered glyphs that are sized correctly relative to the surrounding characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OT_NUMERATOR`}</strong>{` = 1884247150`}</p>
      <p parentName="blockquote">{`For OpenType fonts, shrinks the text but keeps the top of the characters aligned with the top of the main text. Note: Valid only for numeric characters.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OT_DENOMINATOR`}</strong>{` = 1884247140`}</p>
      <p parentName="blockquote">{`For OpenType fonts, shrinks the text but keeps text on the main text baseline. Note: Valid only for numeric characters.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      